export default "__VITE_ASSET__PB$8TpgA__"